import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { appSetToggle, setConfirm } from "../../store/actions/appAction";
import { resetFormState } from "../../store/actions/formAction";
import { apiDeleteWarehouse, apiGetWarehouses } from "../../api/warehouseApi";

import IconDelete from "../../assets/svg/icon-delete-show-account.svg";
import IconEdit from "../../assets/svg/pen-icon-account.svg";
import IconKey from "../../assets/svg/icon-key-account.svg";
import IconMenu from "../../assets/svg/icon-menu-account.svg";
import iconUserInventry from "../../assets/svg/icon-user-inventry.svg";
import logoInventories from "../../assets/svg/logoInventories.svg";
import backgroundInventories from "../../assets/svg/inventory-card-background.svg";
import addNewWarehouse from "../../assets/svg/add-new-warehouse.svg";
import addWork from "../../assets/svg/registerShow/icon-add-work.svg";

import "../../assets/styles/inventory/showWerhoues.scss";

export default function Inventories() {
  const dispatch = useDispatch();

  const inventories = useSelector((state) => state).warehouseReducer.warehouses;
  const toggle = useSelector((state) => state.appReducer.toggle);
  const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);
  const token = useSelector((state) => state).businessReducer.business?.token;

  const [showInventoryActions, setShowInventoryActions] = useState(null);

  // useEffect(() => {
  //     dispatch(resetFormState());
  //     fetchWarehouses();
  // }, []);

  useEffect(() => {
    fetchWarehouses();
  }, [sendingRequest]);

  useEffect(() => {
    if (!toggle) setShowInventoryActions(toggle);
  }, [toggle]);

  const fetchWarehouses = () => {
    dispatch(apiGetWarehouses(token));
  };

  const toggleShowInventoryActions = (id) => {
    dispatch(appSetToggle(showInventoryActions !== id));
    setShowInventoryActions(showInventoryActions === id ? null : id);
  };

  return (
    <div className="wrap-inventory">
      <div className="header-inventory">
        <div className="header-right">
          <div>انبارها</div>
          <div>لیست انبار ها</div>
        </div>
      </div>
      <div className="body-cards row">
        <AddInventoryCard />
        {inventories.map((inventory, index) => (
          <InventoryCard
            key={index}
            inventory={inventory}
            active={toggle && showInventoryActions === inventory.id}
            toggleShowInventoryActions={toggleShowInventoryActions}
          />
        ))}
      </div>
    </div>
  );
}

const AddInventoryCard = () => {
  const navigate = useNavigate();

  return (
    <a
      className="col-lg-4 col-md-4 col-sm-4 col-xs-4 style-body-card"
      href="/inventories/add"
      onClick={(e) => {
        navigate("/inventories/add");
        e.preventDefault();
      }}
    >
      <div className="add-shareholder">
        <div className="wrap-add-shareholder">
          <div className="item-add-shareholder">
            <div className="wrap-icon-add-shareholder">
              <img src={addNewWarehouse} alt="addNewUsers" />
            </div>
            <div className="add-shareholder-new">
              <img className="add-icon-shareholder" src={addWork} alt="addWork" />
              افزودن انبار جدید
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

const InventoryCard = ({ inventory, active, toggleShowInventoryActions }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector((state) => state).businessReducer.business.token;
  const secretView = useSelector((state) => state.appReducer.secretView);

  const deleteInventory = (id) => {
    dispatch(setConfirm("انبار", () => dispatch(apiDeleteWarehouse(id, token))));
  };

  return (
    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 style-body-card">
      <div className="card-box">
        <div className={active ? "active-toggle-menu-account" : "not-active-toggle-menu-account"}>
          <a
            href={`/inventories/${inventory.id}`}
            onClick={(e) => {
              navigate(`/inventories/${inventory.id}`);
              e.preventDefault();
            }}
          >
            <img src={IconEdit} alt="IconEdit" />
            ویرایش
          </a>
          <div onClick={() => deleteInventory(inventory.id)}>
            <img src={IconDelete} alt="IconEdit" />
            حذف انبار
          </div>
        </div>
        <img className="logo-original" src={backgroundInventories} alt="original-logo" />
        <div className="header-card">
          <div className="right-header-card">
            <div />
            <div />
            <div className="logo-card">
              <img src={logoInventories} alt="logo-bank" />
            </div>
          </div>
          <div className="left-header-card">
            <img src={IconMenu} alt="IconMenu" onClick={() => toggleShowInventoryActions(inventory.id)} />
          </div>
        </div>
        <a
          href={`/inventories/supply?warehouseId=${inventory.id}`}
          className="title-card-box"
          onClick={(e) => {
            navigate(`/inventories/supply?warehouseId=${inventory.id}`);
            e.preventDefault();
          }}
        >
          {secretView ? "********" : `${inventory.accountingCode} - ${inventory.title}`}
        </a>
        <div className="branch-card">
          {inventory.branch != null ? (
            <>
              <img src={IconKey} alt="IconKey" />
              <div className="name-branch">{secretView ? "********" : inventory.branch}</div>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="line-card" />
        <div className="footer-card">
          {inventory.warehouseKeeper ? (
            <p className="text-number-card">
              <img className="img-icon-inventory" src={iconUserInventry} alt="iconUserInventry" />
              {secretView ? "********" : inventory.warehouseKeeper}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};
